namespace GeniuzPOS.Administration {
    export class CsVatTypeColumns {
        static columnsKey = 'Administration.CsVatType';
    }
}
